import { SlideTheme } from '@/types/slides'

export const theme: SlideTheme = {
  themeColor: '#5b9bd5',
  fontColor: '#333',
  fontName: '微软雅黑',
  backgroundColor: '#fff',
}